import { z } from 'zod'

const defaultEmailMessage = 'Informe em e-mail válido'

export const emailValidator = z
  .string({
    required_error: 'Campo obrigatório',
    invalid_type_error: defaultEmailMessage,
  })
  .email(defaultEmailMessage)

export const chapterValidator = z.number().min(0).max(9999, 'Número máximo de capítulos é 9999')

export const passwordValidator = z
  .object({
    password: z.string().min(8).max(128, 'A senha deve ter no máximo 128 caracteres').trim(),
    confirmPassword: z.string().min(8).max(128, 'A senha deve ter no máximo 128 caracteres').trim(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas não coincidem',
    path: ['confirmPassword', 'password'],
  })
